import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import CustomLoading from '../../../util_components/custom_loading';
import {
  getCookie,
  image_error_replace,
  session_type,
  hasAccess
} from '../../../../util_functions';
import { time_format, day_format_year, tickImageUrl, closeImageUrl } from '../../../../constants';
import Button from '../../../util_components/button';
import * as actions from '../../../../redux/action_creators';
import { post_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import Paginator from '../../../util_components/paginator';
import DeleteRecordingsModal from '../../../util_components/DeleteRecordingsModal';
import CustomModal from '../../../util_components/custom_modal';
import RecordingOverridesModal from '../../students/student_profile/recording_overrides_modal';
import './sess.css';
import { cancelledByLine } from './cancelled_by';

class UserSessions extends Component {
  state = {
    loading: true,
    input_error: false,
    change_teacher_id: '',
    sessions_list: [],
    is_future: true,
    btn_toggled: false,
    page_number: 1,
    has_next: 0,
    page_limit: 0,
    timezone: getCookie('student_iana_timezone') || '--',
    // delete modal state
    show_delete_modal: false,
    delete_session_uuid: '',
    delete_has_recording: false,
    delete_reason: '',
    delete_loading: false,
    delete_error: '',
    selected_delete_session_uuids: [],
    bulk_delete_all: false, // new flag
    show_recording_overrides: false
  };

  componentDidMount() {
    this.get_url_details();
    this.props.set_home_variable('iana_timezone', 'Asia/Kolkata');
  }

  componentDidUpdate(newProps) {
    if (
      this.props.location.pathname !== newProps.location.pathname ||
      this.props.location.search !== newProps.location.search
    ) {
      this.get_url_details();
    }
  }

  changePage = (page) => {
    window.location.replace(`/pastsessions/backpain?page=${page}`);
  };

  get_url_details = () => {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const uuid = url.searchParams.get('id');
    const user_type = url.searchParams.get('user_type');
    const user_name = url.searchParams.get('name');
    const search_page_number = url.searchParams.get('page');
    const page_number =
      !!search_page_number || search_page_number >= 1 ? parseInt(search_page_number) : 1;
    let is_future = true;
    if (window.location.pathname.indexOf('past') !== -1) {
      is_future = false;
    }
    this.setState({ uuid, user_type, user_name, is_future, page_number }, () => {
      this.load_details();
    });
  };

  go_to_sessions = (id, type) => {
    let search = `?id=${id}`;
    let pathname = '/sessiondetails';
    if (
      type === 'GROUP_SESSION' ||
      type === 'GROUP_SESSION_STUDENT' ||
      type === 'YOGA_WITH_FRIENDS_SESSION' ||
      type === 'YOGA_WITH_FRIENDS_SESSION_STUDENT'
    ) {
      search = `?session_uuid=${id}`;
      if (this.state.user_type === 'STUDENT') {
        search = `${search}&student_uuid=${this.state.uuid}&student_name=${this.state.user_name}`;
      }
      pathname = '/groupsessiondetails';
    }
    this.props.history.push({ pathname, search });
  };

  get_session_url = (id, type) => {
    let search = `?id=${id}`;
    let pathname = '/sessiondetails';
    if (
      type === 'GROUP_SESSION' ||
      type === 'GROUP_SESSION_STUDENT' ||
      type === 'YOGA_WITH_FRIENDS_SESSION' ||
      type === 'YOGA_WITH_FRIENDS_SESSION_STUDENT'
    ) {
      search = `?session_uuid=${id}`;
      if (this.state.user_type === 'STUDENT') {
        search = `${search}&student_uuid=${this.state.uuid}&student_name=${this.state.user_name}`;
      }
      pathname = '/groupsessiondetails';
    }
    return pathname + search;
  };

  load_details = () => {
    const url = get_api_url('get_all_sessions_of_student_or_teacher');
    const payload = {
      timezone: new Date().getTimezoneOffset(),
      user_uuid: this.state.uuid,
      user_type: this.state.user_type,
      is_future: this.state.is_future ? '1' : '0',
      page_number: this.state.page_number
    };
    this.setState({ loading: true }, () => {
      post_api(url, payload, true).then((result) => {
        if (this.state.user_type === 'TEACHER') {
          this.setState(
            { sessions_list: result.data.sessions.result, has_next: result.data.sessions.has_next },
            () => this.setState({ loading: false })
          );
        } else {
          this.setState(
            { sessions_list: result.data.sessions, has_next: result.data.has_next },
            () => this.setState({ loading: false })
          );
        }
      });
    });
  };

  go_back = () => {
    if (!this.state.is_future & this.state.btn_toggled) {
      this.setState({ is_future: true, btn_toggled: false });
    } else {
      this.props.history.goBack();
    }
  };

  open_session_viewer = (session_uuid) => {
    const search = `?session_uuid=${session_uuid}`;
    this.props.history.push({
      pathname: '/session_replay',
      search
    });
  };

  close_video = () => this.setState({ show_video: false });

  open_video = (url) =>
    this.setState({ video_url: url }, () => this.setState({ show_video: true }));

  openDeleteModal = (session) => {
    const hasRecording = session.status === 'FINISHED' && !!session.replay_url;
    this.setState({
      show_delete_modal: true,
      delete_session_uuid: session.session_uuid,
      delete_has_recording: hasRecording,
      delete_reason: '',
      delete_error: ''
    });
  };

  closeDeleteModal = () =>
    this.setState({
      show_delete_modal: false,
      delete_session_uuid: '',
      delete_has_recording: false,
      delete_reason: '',
      delete_error: '',
      delete_loading: false,
      selected_delete_session_uuids: [],
      bulk_delete_all: false
    });

  onChangeDeleteReason = (e) => this.setState({ delete_reason: e.target.value });

  confirmDeleteRecording = async () => {
    const { selected_delete_session_uuids, delete_reason, bulk_delete_all, user_type, uuid } =
      this.state;
    if (delete_reason.trim().length === 0) return;
    if (!bulk_delete_all && selected_delete_session_uuids.length === 0) return;

    this.setState({ delete_loading: true, delete_error: '' });

    let api_url;
    let payload;
    if (bulk_delete_all && user_type === 'STUDENT') {
      api_url = '/v2/crons-tasks/zoom/clear_all_recordings_for_student';
      payload = { student_uuid: uuid, reason: delete_reason.trim() };
    } else {
      api_url = '/v2/crons-tasks/s3/delete_recording_from_s3';
      payload = { session_uuid: selected_delete_session_uuids, reason: delete_reason.trim() };
    }

    const url = get_api_url(api_url, null, true);
    try {
      await post_api(url, payload, true);
      this.props.set_notification_variable(true, 'success', 'Recording(s) deleted successfully');
      this.closeDeleteModal();
      this.load_details();
    } catch (e) {
      this.setState({ delete_loading: false, delete_error: 'Failed. Please try again.' });
      this.props.set_notification_variable(
        true,
        'error',
        'Failed to delete recording(s). Please try again.'
      );
    }
  };

  toggleSelectDelete = (session) => {
    this.setState((prev) => {
      const arr = [...prev.selected_delete_session_uuids];
      const idx = arr.indexOf(session.session_uuid);
      if (idx === -1) arr.push(session.session_uuid);
      else arr.splice(idx, 1);
      return {
        selected_delete_session_uuids: arr
      };
    });
  };

  openBulkDeleteModal = () => {
    if (this.state.selected_delete_session_uuids.length === 0) return;
    this.setState({
      show_delete_modal: true,
      delete_has_recording: true,
      delete_reason: '',
      delete_error: '',
      delete_loading: false,
      bulk_delete_all: false
    });
  };

  deleteAllRecordings = () => {
    const allWithRecording = this.state.sessions_list
      .filter((s) => s.status === 'FINISHED' && !!s.replay_url)
      .map((s) => s.session_uuid);
    if (this.state.user_type !== 'STUDENT') return;
    if (allWithRecording.length === 0) return; // prevent when zero replays
    this.setState({
      bulk_delete_all: true,
      selected_delete_session_uuids: allWithRecording,
      show_delete_modal: true,
      delete_reason: '',
      delete_error: '',
      delete_loading: false
    });
  };

  render_sessions = () => {
    const sessions_list = [...this.state.sessions_list];
    const { page_number, page_limit } = this.state;
    const { access_type } = this.props;
    return (
      <div className="cus-table">
        <div className="ct-row ct-h gap-[19px] pr-[19px]">
          <div className="ct-col text-[12px]">
            {this.state.user_type === 'STUDENT' ? 'Teacher' : 'Student'}
          </div>
          <div className="ct-col ct-hf text-[12px]">Live</div>
          <div className="ct-col text-[12px]">Session Time</div>
          <div className="ct-col ct-h text-[12px]">Local Time</div>
          <div className="ct-col text-[12px]">Booked BY</div>
          <div className="ct-col text-[12px]">Status</div>
          <div className="ct-col ct-hf text-[12px]">Session</div>
          {this.state.user_type === 'STUDENT' && !this.state.is_future ? (
            <>
              <div className="ct-col ct-hf text-[12px] replay-cell-h">Replay</div>
              {hasAccess(access_type, 'SUPER_USER') && (
                <div className="ct-col ct-hf text-[12px] select-replay-cell-h">Select Replay</div>
              )}
              <div className="ct-col ct-hf text-[12px]">Rating</div>
            </>
          ) : this.state.user_type === 'TEACHER' && !this.state.is_future ? (
            <>
              <div className="ct-col ct-hf text-[12px] replay-cell-h">Replay</div>
              <div className="ct-col ct-hf text-[12px]">Rating</div>
            </>
          ) : null}
          {!hasAccess(access_type, 'CONSULT_CONSULTANT') ? (
            <div className="ct-col ct-hf text-[12px]">Session Details</div>
          ) : null}
        </div>
        {sessions_list.map((session, index) => {
          console.log(
            moment(session.epoch_start_time).tz(this.props.iana_timezone).format(time_format)
          );
          const rating =
            session.status !== 'FINISHED' || session.student_rating === 0
              ? '--'
              : session.student_rating;
          const rating_color =
            session.student_rating > 3 ? 'green' : session.student_rating > 0 ? 'red' : 'auto';
          let profile_url;
          if (this.state.user_type === 'TEACHER') {
            profile_url = `/studentprofile?id=${session.student_uuid}`;
          } else {
            profile_url = `/teacherprofile?id=${session.teacher_uuid}`;
          }
          const cancelled_status = [
            'CANCELLED',
            'CANCELLED_BY_TEACHER',
            'CANCELLED_BY_STUDENT',
            'NO_SHOW_CANCELLATION_1HOUR',
            'TEACHER_NO_SHOW',
            'STUDENT_NO_SHOW',
            'STUDENT_AND_TEACHER_NO_SHOW',
            'JOINED_BUT_CANCELLED',
            'NO_SHOW_WITH_RECORDING'
          ];
          const status_style =
            cancelled_status.indexOf(session.status) === -1
              ? { color: '#016601' }
              : { color: '#ED4D4D' };
          const is_group =
            session.type === 'GROUP_SESSION' || session.type === 'GROUP_SESSION_STUDENT';
          let created_href = '';
          if (!!session.session_created_by_uuid && session.session_created_by_type == 'teacher') {
            created_href = `/teacherprofile?id=${session.session_created_by_uuid}`;
          } else if (
            !!session.session_created_by_uuid &&
            session.session_created_by_type == 'student'
          ) {
            created_href = `/studentprofile?id=${session.session_created_by_uuid}`;
          }
          const isSelected = this.state.selected_delete_session_uuids.includes(
            session.session_uuid
          );
          const iconColor = isSelected && '#007BFF';
          const cancelled_line = cancelledByLine(
            session,
            this.props.iana_timezone,
            `${day_format_year}, ${time_format}`
          );
          const hasReplay =
            session.status === 'FINISHED' && !!session.replay_url && session.type === 'YOGA';
          return (
            <div className="ct-row" key={index + session.session_uuid}>
              <div className="ct-col ct-sm-font">
                <a className="link-no-dec" href={profile_url}>
                  <div className="profile-img-name">
                    {this.state.user_type === 'TEACHER' ? (
                      <img src={session.avatar_medium} alt="i" onError={image_error_replace} />
                    ) : (
                      <img
                        src={session.teacher_profile_photo}
                        alt="i"
                        onError={image_error_replace}
                      />
                    )}
                    {this.state.user_type === 'STUDENT'
                      ? session.teacher_name
                      : session.student_name}
                  </div>
                  {is_group ? <div>{`(${session.group_session_name})`}</div> : null}
                </a>
              </div>
              <div className="ct-col ct-hf">
                {session.is_live === 1 ? (
                  <div className="led-green" />
                ) : (
                  <div className="led-grey" />
                )}
              </div>
              <div className="ct-col ct-sm-font">
                <div>
                  {moment(session.epoch_start_time)
                    .tz(this.props.iana_timezone)
                    .format(day_format_year)}
                </div>
                <div>
                  {moment(session.epoch_start_time)
                    .tz(this.props.iana_timezone)
                    .format(time_format)}
                </div>
                <div>{`(${session.duration} mins)`}</div>
              </div>
              <div className="ct-col text-[10px]">
                <div>
                  {moment(session.epoch_start_time).tz(this.state.timezone).format(day_format_year)}
                </div>
                <div>
                  {moment(session.epoch_start_time).tz(this.state.timezone).format(time_format)}
                </div>
                <div>{`(${session.duration} mins)`}</div>
              </div>
              <div className="ct-col ct-sm-font">
                <a href={created_href} target="_blank" rel="noopener noreferrer">
                  <div>{session?.session_created_by_name}</div>
                  <div>{`(${session?.session_created_by_type})`}</div>
                </a>
              </div>
              <div className="ct-col ct-bw ct-sm-font" style={status_style}>
                {session.status}
                {session.status === 'CANCELLED' &&
                !!session.can_diff_hrs &&
                session.can_diff_hrs < 12 ? (
                  <span style={{ display: 'block' }}>(Less than 12 Hrs)</span>
                ) : null}
                {cancelled_line ? (
                  <span
                    data-testid="session-cancelled-by"
                    style={{ display: 'block', color: 'var(--text-muted)', marginTop: 2 }}
                  >
                    {cancelled_line}
                  </span>
                ) : null}
              </div>
              <div className="ct-col ct-si ct-hf ct-sm-font">
                <div>{session_type(session.type)}</div>
                <div>
                  {session.is_recurring === 1 ? (
                    <img
                      src="https://images.myyogateacher.com/icons/ic_repeat@2x.png"
                      alt="ic_rep"
                    />
                  ) : null}
                </div>
              </div>
              {this.state.user_type === 'STUDENT' && !this.state.is_future ? (
                <>
                  <div className="ct-col ct-hf replay-cell">
                    {session.status === 'FINISHED' ? (
                      session.replay_url ? (
                        <img src={tickImageUrl} alt="ok" />
                      ) : (
                        <img src={closeImageUrl} alt="na" />
                      )
                    ) : (
                      <img src={closeImageUrl} alt="na" />
                    )}
                  </div>
                  {hasAccess(access_type, 'SUPER_USER') ? (
                    <div className="ct-col ct-hf select-replay-cell">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        disabled={!hasReplay}
                        onChange={() => hasReplay && this.toggleSelectDelete(session)}
                        style={{
                          cursor: hasReplay ? 'pointer' : 'not-allowed',
                          accentColor: iconColor
                        }}
                        aria-label="Select recording for deletion"
                      />
                    </div>
                  ) : null}
                  <div
                    className="ct-col rating-col ct-hf"
                    style={{ fontSize: '16px', color: rating_color }}
                  >
                    {rating}
                  </div>
                </>
              ) : this.state.user_type === 'TEACHER' && !this.state.is_future ? (
                <>
                  <div className="ct-col ct-hf replay-cell">
                    {session.status === 'FINISHED' ? (
                      session.replay_url ? (
                        <img src={tickImageUrl} alt="ok" />
                      ) : (
                        <img src={closeImageUrl} alt="na" />
                      )
                    ) : (
                      <img src={closeImageUrl} alt="na" />
                    )}
                  </div>
                  <div
                    className="ct-col rating-col ct-hf"
                    style={{ fontSize: '16px', color: rating_color }}
                  >
                    {rating}
                  </div>
                </>
              ) : null}
              {!hasAccess(access_type, 'CONSULT_CONSULTANT') ? (
                <div className="ct-col ct-hf">
                  <a
                    href={this.get_session_url(session.session_uuid, session.type)}
                    className="ct-small-btn link-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Details
                  </a>
                </div>
              ) : null}
            </div>
          );
        })}
        <Paginator curr_page={page_number} page_limit={page_limit} pageChange={this.changePage} />
      </div>
    );
  };

  toggle_is_future = () => {
    let pathname = '/usersessions/future';
    if (this.state.is_future) {
      pathname = '/usersessions/past';
    }
    this.props.history.push({ pathname, search: window.location.search });
  };

  open_repeat_sessions = () => {
    const search = `?uuid=${this.state.uuid}`;
    this.props.history.push({
      pathname: '/repeat_sessions',
      search
    });
  };

  open_teacher_repeat_sessions = () => {
    const search = `?uuid=${this.state.uuid}`;
    this.props.history.push({
      pathname: '/repeat_sessions/teacher',
      search
    });
  };

  get_search = (is_next) => {
    const { uuid, user_type, user_name, page_number } = this.state;
    let search = `id=${uuid}`;
    if (user_type) search += `&user_type=${user_type}`;
    if (is_next) search += `&page=${page_number + 1}`;
    if (!is_next) search += `&page=${page_number - 1}`;
    if (user_name) search += `&name=${encodeURI(user_name)}`;
    return search;
  };

  go_prev_page = () => {
    const search = this.get_search(false);
    this.props.history.push({
      pathname: window.location.pathname,
      search
    });
  };

  go_next_page = () => {
    const search = this.get_search(true);
    this.props.history.push({
      pathname: window.location.pathname,
      search
    });
  };

  render_page = () => {
    const { page_number, has_next } = this.state;
    return (
      <div className="user-sess-page">
        <img
          className={page_number <= 1 ? 'user-sess-page-dis' : ''}
          src="https://images.myyogateacher.com/website/home/arrow_back.png"
          alt="arr"
          onClick={this.go_prev_page}
        />
        <img
          className={`user-sess-page-rev ${has_next === 0 ? 'user-sess-page-dis' : ''}`}
          src="https://images.myyogateacher.com/website/home/arrow_back.png"
          alt="arr"
          onClick={this.go_next_page}
        />
      </div>
    );
  };

  render_function = () => {
    if (this.state.loading) {
      return <CustomLoading />;
    }
    let user_name = '';
    try {
      user_name = this.state.user_name.toUpperCase();
    } catch (e) {}
    const sessions_str =
      this.state.user_type === 'STUDENT'
        ? 'Sessions'
        : this.state.is_future
          ? 'Future sessions'
          : 'Past sessions';
    const hasAnyReplay = this.state.sessions_list.some(
      // check if any replay exists
      (s) => s.status === 'FINISHED' && !!s.replay_url
    );
    const { access_type } = this.props;
    return (
      <div className="common-page-container">
        {this.props.zoom_signature_status === 'loading' ? <CustomLoading /> : null}
        <div className="common-page-header">
          <div className="profile-go-back" onClick={this.go_back}>
            <img
              src="https://s3.amazonaws.com/images.myyogateacher.com/website/home/arrow_back.png"
              alt="back"
            />
            <span>Back</span>
          </div>
          <div className="common-page-title">
            <span style={{ color: 'var(--text-muted)' }}>
              {sessions_str} of {this.state.user_type}{' '}
              <span style={{ color: 'var(--text-primary)', fontSize: '18px' }}>{user_name}</span>
            </span>
          </div>
        </div>
        <div>
          <Button
            onClick={this.toggle_is_future}
          >{`${this.state.is_future ? 'Past' : 'Future'} Sessions`}</Button>
          {this.state.user_type === 'STUDENT' && !!this.state.uuid ? (
            <Button onClick={this.open_repeat_sessions}>Repeat sessions</Button>
          ) : null}
          {this.state.user_type === 'STUDENT' &&
          !!this.state.uuid &&
          hasAccess(access_type, 'SUPER_USER') ? (
            <Button onClick={() => this.setState({ show_recording_overrides: true })}>
              Recording Overrides
            </Button>
          ) : null}
          {this.state.user_type === 'TEACHER' && !!this.state.uuid ? (
            <Button onClick={this.open_teacher_repeat_sessions}>Repeat sessions</Button>
          ) : null}
          {this.state.user_type === 'STUDENT' &&
          !this.state.is_future &&
          hasAccess(access_type, 'SUPER_USER') ? (
            <>
              <Button
                onClick={this.openBulkDeleteModal}
                disabled={this.state.selected_delete_session_uuids.length === 0}
              >
                Delete Recording
              </Button>
              <Button onClick={this.deleteAllRecordings} disabled={!hasAnyReplay}>
                Delete All Recordings
              </Button>
            </>
          ) : null}
        </div>
        {this.render_sessions()}
        {this.render_page()}
        <DeleteRecordingsModal
          show={this.state.show_delete_modal}
          bulk_delete_all={this.state.bulk_delete_all}
          selectedCount={this.state.selected_delete_session_uuids.length}
          delete_reason={this.state.delete_reason}
          delete_error={this.state.delete_error}
          delete_loading={this.state.delete_loading}
          onChangeDeleteReason={this.onChangeDeleteReason}
          onCancel={this.closeDeleteModal}
          onConfirm={this.confirmDeleteRecording}
        />
        <CustomModal
          show={!!this.state.show_recording_overrides}
          close={() => this.setState({ show_recording_overrides: false })}
          title="Recording Overrides"
          inner_style={{ width: '820px', maxWidth: '95vw', overflow: 'visible' }}
        >
          {this.state.show_recording_overrides ? (
            <RecordingOverridesModal
              student_uuid={this.state.uuid}
              iana_timezone={this.props.iana_timezone}
              set_notification_variable={this.props.set_notification_variable}
              close={() => this.setState({ show_recording_overrides: false })}
            />
          ) : null}
        </CustomModal>
      </div>
    );
  };

  render() {
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>User Sessions</title>
        </Helmet>
        {this.render_function()}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  zoom_signature_status: state.loading.zoom_signature_status,
  iana_timezone: state.home.iana_timezone,
  access_type: state.home.access_type
});

const mapDispatchToProps = (dispatch) => ({
  set_home_variable: (key, payload) => dispatch(actions.set_home_variable(key, payload)),
  set_notification_variable: (show, type, mes) => {
    dispatch(actions.set_notification_variable(show, type, mes));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(UserSessions);
